"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLoadingSelector = exports.hasErrorSelector = exports.getProductId = exports.dateFormatSelector = exports.configSelector = void 0;
var _appConstants = require("../appConstants");
var configSelector = function configSelector(state) {
  var _state$config, _state$config$data;
  // if (!state.config?.data?.widgets) return null;
  var myWidget = (_state$config = state.config) === null || _state$config === void 0 ? void 0 : (_state$config$data = _state$config.data) === null || _state$config$data === void 0 ? void 0 : _state$config$data.widgets[_appConstants.PKG_NAME];
  if (myWidget) {
    var insID = Object.keys(myWidget)[0];
    return myWidget[insID];
  }
  return null;
};
exports.configSelector = configSelector;
var isLoadingSelector = function isLoadingSelector(state) {
  var _state$PKG_NAME;
  return (_state$PKG_NAME = state[_appConstants.PKG_NAME]) === null || _state$PKG_NAME === void 0 ? void 0 : _state$PKG_NAME.isLoading;
};
exports.isLoadingSelector = isLoadingSelector;
var hasErrorSelector = function hasErrorSelector(state) {
  var _state$PKG_NAME2;
  return (_state$PKG_NAME2 = state[_appConstants.PKG_NAME]) === null || _state$PKG_NAME2 === void 0 ? void 0 : _state$PKG_NAME2.hasError;
};
exports.hasErrorSelector = hasErrorSelector;
var getProductId = function getProductId(state) {
  var _state$props, _state$props$topupLis;
  return (_state$props = state.props) === null || _state$props === void 0 ? void 0 : (_state$props$topupLis = _state$props.topupList) === null || _state$props$topupLis === void 0 ? void 0 : _state$props$topupLis.phoneNumber;
};
exports.getProductId = getProductId;
var dateFormatSelector = function dateFormatSelector(state) {
  var _state$config2, _state$config2$data, _state$config2$data$g;
  return (_state$config2 = state.config) === null || _state$config2 === void 0 ? void 0 : (_state$config2$data = _state$config2.data) === null || _state$config2$data === void 0 ? void 0 : (_state$config2$data$g = _state$config2$data.global) === null || _state$config2$data$g === void 0 ? void 0 : _state$config2$data$g.dateFormat;
};
exports.dateFormatSelector = dateFormatSelector;